import { render, staticRenderFns } from "./Expire_stock.vue?vue&type=template&id=033d42a0&scoped=true&"
import script from "./Expire_stock.vue?vue&type=script&lang=js&"
export * from "./Expire_stock.vue?vue&type=script&lang=js&"
import style0 from "./Expire_stock.vue?vue&type=style&index=0&id=033d42a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d42a0",
  null
  
)

export default component.exports